import {useTimeUnitTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  Countdown as CountdownUiComponent,
  CountdownUnitProps,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  Text,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

interface CountdownProps {
  endsAt: Date;
  className?: string;
}

export const Countdown: React.FC<CountdownProps> = ({endsAt, className}) => {
  return (
    <Container className={className}>
      <StyledIcon asset={GenericIconName.Clock} fill="white" />
      <CountdownUiComponent
        endDate={endsAt}
        containerComponent={CountdownContainer}
        unitComponent={CountdownUnit}
      />
    </Container>
  );
};

const CountdownUnit: React.FC<CountdownUnitProps> = ({value, unit}) => {
  const timeFormat = useTimeUnitTranslation('shorter');

  if (value === '00' && unit === 'days') {
    return null;
  }

  return (
    <Label>
      {value}
      {timeFormat[unit]}
    </Label>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 1px 4px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.1);
  box-sizing: content-box;

  ${tabletAndUp(css`
    gap: 8px;
    padding: 0 12px 0 8px;
    border-radius: 5px;
  `)}
`;

const StyledIcon = styled(Icon)`
  width: 20px;
  height: 20px;

  ${tabletAndUp(css`
    width: 40px;
    height: 40px;
  `)}
`;

const CountdownContainer = styled.div`
  display: flex;
  gap: 0.5ch;
`;

const Label = styled(Text)`
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 21px;
  color: ${COLORS.White};
  text-transform: uppercase;

  ${tabletAndUp(css`
    font-size: ${FONT_SIZES.px24};
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
    line-height: ${FONT_SIZES.px46};
  `)}
`;
